/* eslint-disable */
import * as React from 'react';
import { CalendarPropsType } from './types';
import { CalendarContext } from './CalendarContext';

export const CalendarContextReact = React.createContext<CalendarContext>(new CalendarContext(false, 12, id => id));

export const Calendar: React.FC<CalendarPropsType> = ({ children, multiple, groupSize = 12, fillBlanks, items, value = null, groupMask }) => {
  const context = React.useMemo(() => new CalendarContext(Boolean(multiple), groupSize, fillBlanks, groupMask), [multiple, groupSize, fillBlanks]);
  React.useEffect(() => {
    if (items) {
      context.setItems(items);
    }
  }, [items]);

  React.useEffect(() => {
    context.setValue(value);
  }, [value]);

  return React.useMemo(() => (<CalendarContextReact.Provider value={context}>
    {children}
  </CalendarContextReact.Provider>), [context, JSON.stringify(items), JSON.stringify(value), children]);
}

